import client from '../httpClient';

const customerGetStatisticsApi = (customerId) => {
  const GET_STATICS_TELS_URL = `/customers/statistics/tels/${customerId}`;
  return client.get(GET_STATICS_TELS_URL, String(customerId));
};

export default customerGetStatisticsApi;
